import {useEffect, useState} from 'react';
import useQuery from './useQuery';
import axios from 'axios';

const useSuperUser = () => {
    const query = useQuery();

    const [accountId, setAccountId] = useState<string>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const accountId = query.get('account');
        if (accountId || axios.defaults.headers.common['X-ON-BEHALF-OF']) {
            setAccountId(accountId);
            axios.defaults.headers.common['X-ON-BEHALF-OF'] = accountId;
        }
        setIsLoaded(true);
    }, [query]);

    return {accountId, isLoaded};
};

export default useSuperUser;
